export enum OddsAcceptance {
    No = 'No',
    Any = 'Any',
    Higher = 'Higher',
}
